import { Component, Input } from '@angular/core';

import { GridItem, GridColumnChildren } from '../../grid-control.model';

@Component({
  selector: 'sd-grid-desktop-column-children-view',
  templateUrl: './grid-desktop-column-children-view.component.html',
  styleUrls: ['./grid-desktop-column-children-view.component.scss']
})
export class GridDesktopColumnChildrenViewComponent {
  @Input() column: GridColumnChildren;
  @Input() item: GridItem;
  constructor(
  ) { }
}
